import { Button as AntButton } from "antd"
import { ButtonProps, ButtonSize, ButtonType } from "antd/lib/button"
import { classNames } from "../../../utils/classNames"
import { omit } from "ramda"
import * as React from "react"

type Props = Omit<ButtonProps, "icon" | "size" | "type"> & {
    fullWidth?: boolean
    icon?: React.ReactNode
    size?: ButtonSize | "large" | "x-large"
    type?: "danger" | "danger2" | "default" | "primary" | "ghost" | "link" | "text" | "dashed"
}

export const Button = (props: Props) => {
    const restButtonProps: ButtonProps = omit(["className", "fullWidth", "icon", "size", "type"], props)
    return (
        <AntButton
            // todo: fix types
            size={props.size as ButtonSize}
            type={props.type as ButtonType}
            className={classNames(
                props.className,
                props.fullWidth && classes.fullWidth,
                props.size && classes.size[props.size],
                props.type && !props.disabled && classes.type[props.type]
            )}
            {...restButtonProps}>
            {props.icon ? (
                <div className={classes.withIconWrap}>
                    <div className={classes.iconWrap}>{props.icon}</div>
                    <div>{props.children}</div>
                </div>
            ) : (
                props.children
            )}
        </AntButton>
    )
}

const classes = {
    fullWidth: "w-full block",
    iconWrap: "[&>*]:mt-px [&>*]:block",
    size: {
        large: "px-7 text-[15px] h-[38px]",
        "x-large": "px-7 text-[16px] h-[42px]",
    },
    type: {
        danger: "bg-[#FAFAFA] text-[#FF4949] hover:border-[#FF4949] hover:text-[#E54141]",
        danger2: "bg-error text-[#FFFFFF] hover:bg-error/90 border-0",
    },
    disabled: "bg-[#FAFAFA] text-[#B0B0B0] hover:border-[#B0B0B0] hover:text-[#B0B0B0]",
    withIconWrap: "flex items-center justify-center space-x-2",
}
